export default {"src":"/_next/static/media/zustand.692e5040.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};